const AlterarSenha = () => import('@/views/AlterarSenha.vue');

const routes = [
  {
    path: '/meu-perfil/alterar-senha',
    name: 'alterar-senha',
    component: AlterarSenha,
    meta: {
      title: 'Alterar minha senha',
    },
  },
];

export default routes;
